import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    role_list: [],
    table: {
      loading: false,
      role_loading: false,
      loading_user_id: null,
      column_loading: '',
      items_per_page: 10,
      page: 1,
      total_items: 0,
      headers: [
        { title: Vuetify.locale.t('$vuetify.__Login.username'), key: 'username', width: 180 },
        { title: Vuetify.locale.t('$vuetify.__AdminSetting.users.user_mngt_dialog.role'), key: 'role', width: 180 },
        { title: Vuetify.locale.t('$vuetify.__AdminSetting.users.user_mngt_dialog.name'), key: 'name' },
        { title: Vuetify.locale.t('$vuetify.__AdminSetting.users.user_mngt_dialog.email'), key: 'email' },
        { title: Vuetify.locale.t('$vuetify.__AdminSetting.users.user_mngt_dialog.post'), key: 'remark_1' },
        { title: '', key: 'action', sortable: false, width: 300 }
      ],
      items: []
    }
  },
  mutations: {
    SET_USER_SETTINGS_TABLE_LOADING(state, payload) {
      state.table.loading = payload
    },
    SET_USER_SETTINGS_TABLE_PAGE(state, payload) {
      state.table.page = payload
    },
    SET_USER_SETTINGS_TABLE_ITEMS_PER_PAGE(state, payload) {
      state.table.items_per_page = payload
    },
    SET_USER_SETTINGS_TABLE_TOTAL_ITEMS(state, payload) {
      state.table.total_items = payload
    },
    SET_USER_SETTINGS_TABLE_ITEMS(state, payload) {
      state.table.items = payload
    },
    SET_USER_SETTINGS_COLUMN_LOADING(state, payload) {
      state.table.loading_user_id = payload.user_id
      state.table.column_loading = payload.column
    },
    SET_USER_SETTINGS_ROLE_LIST(state, payload) {
      state.role_list = payload
    }
  },
  actions: {
    async fetchUserList({ state, commit }, payload) {
      try {
        if (payload?.options?.page) commit('SET_USER_SETTINGS_TABLE_PAGE', payload.options.page)
        if (payload?.options?.itemsPerPage) commit('SET_USER_SETTINGS_TABLE_ITEMS_PER_PAGE', payload.options.itemsPerPage)

        commit('SET_USER_SETTINGS_TABLE_LOADING', true)
        commit('SET_USER_SETTINGS_TABLE_ITEMS', [])

        const page = state.table.page
        const itemsPerPage = state.table.items_per_page
        const response = await api.getUserList({ limit: itemsPerPage, offset: page * itemsPerPage - itemsPerPage })
        if (response.data.success) {
          commit('SET_USER_SETTINGS_TABLE_ITEMS', response.data.data)
          commit('SET_USER_SETTINGS_TABLE_TOTAL_ITEMS', response.data.total)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_USER_SETTINGS_TABLE_LOADING', false)
      }
    },

    async fetchRoleList({ commit }) {
      try {
        const response = await api.getUserRoles()
        if (response.data.success) {
          commit('SET_USER_SETTINGS_ROLE_LIST', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      }
    },

    async updateUserDetails({ rootState, commit, dispatch }, { user_id, params, column }) {
      try {
        commit('SET_USER_SETTINGS_COLUMN_LOADING', { user_id: user_id, column: column })
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.updating', ''), loading: true })

        const response = await api.updateUser({ params: { device_id: rootState.auth.selected_device, user_id: user_id, ...params } })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_USER_SETTINGS_COLUMN_LOADING', { user_id: null, column: '' })
        dispatch('fetchUserList')
      }
    }
  }
}
